import Logout from "@/pages/logout";
import LoginContainer from "../pages/auth/login/login.container";
import SignupContainer from "../pages/auth/signup/signup.container";
import {
  PATH_ACCEPT_INVITE,
  PATH_FORGOT_PASSWORD,
  PATH_LOGIN,
  PATH_LOGOUT,
  PATH_RESET_PASSWORD,
  PATH_SIGNUP,
} from "./paths";
import ForgotPasswordContainer from "@/pages/auth/forgot-password/forgot-password.container";
import ResetPasswordContainer from "@/pages/auth/reset-password/reset-password.container";
import AcceptInviteContainer from "@/pages/auth/accept-invite/accept.invite.container";

const authRoutes = [
  {
    path: PATH_LOGIN,
    element: <LoginContainer />,
  },
  {
    path: PATH_RESET_PASSWORD,
    element: <ResetPasswordContainer />,
  },
  {
    path: PATH_FORGOT_PASSWORD,
    element: <ForgotPasswordContainer />,
  },

  {
    path: PATH_LOGOUT,
    element: <Logout />,
  },

  {
    path: PATH_SIGNUP,
    element: <SignupContainer />,
  },
  {
    path: PATH_ACCEPT_INVITE,
    element: <AcceptInviteContainer />,
  },
];

export default authRoutes;
